import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of, switchMap, zip } from 'rxjs';
import { Store } from '@ngrx/store';

import { StoreApiService } from '@paymash/sdk/api/v2';
import { selectCompanyUuid } from '@public-page/store/company';
import { selectStoreUuid } from '@modules/company-page/store/company-stores';

import {
  BookingSelectServicesActions,
  BookingSelectServicesApiActions,
  BookingSessionStorageActions,
} from './services.actions';
import { SessionStorageService } from '@modules/core/services';
import { SessionStorageKeysEnum } from '@modules/core/enums';
import { BookingSelectServicesCategoriesActions } from '@modules/booking/store/categories';

@Injectable()
export class ServicesEffects {
  constructor(
    private actions$: Actions,
    private storeApiService: StoreApiService,
    private store: Store,
    private sessionStorageService: SessionStorageService
  ) {}

  unSelectAllServices$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BookingSelectServicesCategoriesActions.componentLoaded),
      map(() => BookingSelectServicesActions.unselectAllServices())
    );
  });

  loadServices$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BookingSelectServicesCategoriesActions.componentLoaded),
      switchMap(() =>
        zip(this.store.select(selectCompanyUuid), this.store.select(selectStoreUuid)).pipe(
          exhaustMap(([companyUuid, StoreUuid]) => {
            return this.storeApiService.getServices(companyUuid, StoreUuid);
          }),
          map((services) => BookingSelectServicesApiActions.loadSuccess({ services })),
          catchError(() => of(BookingSelectServicesApiActions.loadFailure))
        )
      )
    );
  });

  loadServicesFromStorage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BookingSessionStorageActions.loadSelectedServices),
      switchMap(() => {
        return of(this.sessionStorageService.getData<Array<string>>(SessionStorageKeysEnum.selectedServices));
      }),
      map((services) => {
        const servicesData = services || [];
        return BookingSessionStorageActions.setSelectedServices({ selectedServices: servicesData })
      })
    );
  });
}
